import axios from 'axios'
import { refreshService } from './authx'

export const getAxiosInstance = (token: string) => {
  const axiosInstance = axios.create()
  axiosInstance.defaults.headers = { Authorization: `Bearer ${token}` }
  axiosInstance.interceptors.response.use(response => {
    return response
  }, error => {
    if (error.response.status === 401) {
      const refreshToken = localStorage.getItem('refreshToken')

      refreshService(refreshToken).then(res => {
        if (res.access_token) {
          localStorage.setItem('accessToken', res.access_token)
          localStorage.setItem('refreshToken', res.refresh_token)
        } else {
          localStorage.removeItem('accessToken')
          localStorage.removeItem('refreshToken')
        }
        location.reload()
      }).catch(() => {
        localStorage.removeItem('accessToken')
        localStorage.removeItem('refreshToken')
        location.reload()
      })
    }
    return error
  })
  return axiosInstance
}
